import lodash from 'lodash';

// I remove nulls & undefined from things.
// Any is here because the types get massacred.
export const cleanupRequest = (someObject: any): any => {
  if (lodash.isArray(someObject)) {
    return lodash(someObject).map(cleanupRequest).value();
  }
  if (typeof someObject === 'string') {
    return someObject;
  }
  return lodash(someObject)
    .pickBy(lodash.isObject)
    .mapValues(cleanupRequest)
    .assign(lodash.omitBy(someObject, (t) => lodash.isObject(t) || lodash.isNil(t)))
    .value();
};

// I remove undefined from things and leave nulls.
// Any is here because the types get massacred.
export const cleanupRequestWithNulls = (someObject: any): any => {
  if (lodash.isArray(someObject)) {
    return lodash(someObject).map(cleanupRequest).value();
  }
  if (typeof someObject === 'string') {
    return someObject;
  }
  return lodash(someObject)
    .pickBy(lodash.isObject)
    .mapValues(cleanupRequest)
    .assign(lodash.omitBy(someObject, (t) => lodash.isObject(t) || lodash.isUndefined(t)))
    .value();
};
